import { makeObservable, observable, action } from 'mobx';

export class SettingsStore {
    isMsalInteractionRequired = false;
    isReloginRequired = false;

    constructor() {
        makeObservable(this, {
            isMsalInteractionRequired: observable,
            isReloginRequired: observable,

            setIsMsalInteractionRequired: action,
            setIsReloginRequired: action
        });
    }

    setIsMsalInteractionRequired = (value: boolean) => {
        this.isMsalInteractionRequired = value;
    };

    setIsReloginRequired = (value: boolean) => {
        this.isReloginRequired = value;
    };
}

export const settingsStore = new SettingsStore();

export default { settingsStore };
